// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"1e0ffaae","156":"a31f658e","219":"fd0c70cc","371":"ae5c9c43","453":"5d9d47fd","597":"5cfc18ba","909":"94627440"}[chunkId] + ".chunk.js";
};